import React from 'react';

interface IProps {
  width?: number;
  height?: number;
  fill?: string;
}

export const EditIcon = ({
  width = 24,
  height = 24,
  fill = '#16151C',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={'cursor-pointer'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21H21M13.7844 5.31171C13.7844 5.31171 13.7844 6.94634 15.419 8.58096C17.0537 10.2156 18.6883 10.2156 18.6883 10.2156M7.31963 17.9881L10.7523 17.4977C11.2475 17.4269 11.7064 17.1975 12.06 16.8438L20.3229 8.58096C21.2257 7.67818 21.2257 6.21449 20.3229 5.31171L18.6883 3.67708C17.7855 2.77431 16.3218 2.77431 15.419 3.67708L7.15616 11.94C6.80248 12.2936 6.57305 12.7525 6.50231 13.2477L6.01193 16.6804C5.90295 17.4432 6.5568 18.097 7.31963 17.9881Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const TrashIcon = ({
  width = 20,
  height = 22,
  fill = '#16151C',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      className={'cursor-pointer'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 8L16.2841 17.3068C16.1238 19.3908 14.386 21 12.2959 21H7.70412C5.61398 21 3.87621 19.3908 3.71591 17.3068L3 8M19 6C16.4021 4.73398 13.3137 4 10 4C6.68635 4 3.59792 4.73398 1 6M8 4V3C8 1.89543 8.89543 1 10 1C11.1046 1 12 1.89543 12 3V4M8 10V16M12 10V16"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const EyeIcon = ({
  width = 22,
  height = 16,
  fill = '#16151C',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 16"
      className={'cursor-pointer'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1303 5.8531C21.2899 7.07317 21.2899 8.92683 20.1303 10.1469C18.1745 12.2047 14.8155 15 11 15C7.18448 15 3.82549 12.2047 1.86971 10.1469C0.710098 8.92683 0.710098 7.07317 1.86971 5.8531C3.82549 3.79533 7.18448 1 11 1C14.8155 1 18.1745 3.79533 20.1303 5.8531Z"
        stroke={fill}
        strokeWidth="1.5"
      />
      <path
        d="M14 8C14 9.65685 12.6569 11 11 11C9.34315 11 8 9.65685 8 8C8 6.34315 9.34315 5 11 5C12.6569 5 14 6.34315 14 8Z"
        stroke={fill}
        strokeWidth="1.5"
      />
    </svg>
  );
};
